import { ControlIntent } from "./ControlIntent"
import { ControlStateOptions } from "./ControlStateOptions"

/**
 *  Determine the CSS class for the cursor of a control elements.
 */
export function determineControlCursorClass(state: ControlStateOptions, intent: ControlIntent = "editable") {
  if (state.disabled) {
    return "cursor-not-allowed"
  }

  // if the control is clickable, we want to make sure that the cursor is a pointer
  // as the text cursor would indicate that we can edit/select text on the control.
  if (intent === "clickable") {
    return "cursor-pointer"
  }

  return "cursor-text"
}
